// extracted by mini-css-extract-plugin
module.exports = {"switcherContainer":"Switcher-module--switcher-container--3u9FS","switcherItem":"Switcher-module--switcher-item--3mWIH","selected":"Switcher-module--selected--LEuFn"};